/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import OrderList from '../OrderElement/OrderList'
import { Icon, Segment } from 'semantic-ui-react'
import { useCurrentOrders } from '../OrdersCurrent/useCurrentOrders'
import { sortByPickupDescThenReceivedDateDesc } from '../OrdersCurrent'
import { useTranslation } from 'react-i18next'
import { isToday } from "date-fns";
import React from 'react'

const OrderScheduled = () => {
    const [t] = useTranslation()
    const {orders} = useCurrentOrders()
    const scheduledOrders = (orders || [])
      .filter(order => order.isScheduledForLater)
      .sort(sortByPickupDescThenReceivedDateDesc)

    const getStatusText = (order) => {
        const scheduledAtDate = new Date(order.scheduledAt)

        if (isToday(scheduledAtDate)) {
            return t('order.scheduled.scheduled_for_today', {
                time: scheduledAtDate.toLocaleTimeString(localStorage.getItem('ulty-lng'), {
                    hour: 'numeric',
                    minute: '2-digit',
                }),
            })
        }

        return t('order.scheduled.scheduled_for', {
            dt: scheduledAtDate.toLocaleString(localStorage.getItem('ulty-lng'), {
                weekday: 'short',
                day: 'numeric',
                month: 'long',
                hour: 'numeric',
                minute: '2-digit',
            }),
        })
    }

    return (
      <Segment
        loading={!orders}
        css={css`
          &.ui.segment {
              margin-top: 0;
          }
      `}>
          <OrderList
            seeText={t('order.notification.handle')}
            emptyText={t('order.all_handled')}
            loading={!scheduledOrders}
            orders={scheduledOrders}
            displayDelivery
            getStatusText={(order) => <div><Icon name='calendar check outline' />{getStatusText(order)}</div>}
          />
      </Segment>
    )
}

export { OrderScheduled }
